import React from "react";
import mapboxgl from "mapbox-gl";
import _ from "lodash";

import { MAP_ACTIONS, MAPBOX_TOKEN } from "./utils/constants.js";
import { getLineGeojsonFromPoints, getPointsFromGeojson } from "./utils/index.js";

import IconImport from "./assets/icon_import.svg";
import IconExport from "./assets/icon_export.svg";
import IconDelete from "./assets/icon_delete.svg";

import Map from "./components/map.jsx";

mapboxgl.accessToken = MAPBOX_TOKEN;

class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      lat: 12.977529081680132,
      lng: 77.57247169985196,
      zoom: 11,
      supported: mapboxgl.supported(),
      fileReadError: "",
      points: [],
      selectedPointIndex: -1,
    };

    this.importInput = React.createRef();
  }

  onFileUploadSuccess = (newGeojson) => {
    const { coordinates } = newGeojson.features[0].geometry;
    const points = _.map(coordinates, c => ([c[0], c[1]]));
    this.setState({
      points,
    });
  };

  readFile = (e) => {
    this.setState({
      fileReadError: "",
    });
    try {
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        const content = fileReader.result;
        const geojsonData = JSON.parse(content);
        this.onFileUploadSuccess(geojsonData);
      }
      fileReader.readAsText(file);
    } catch(e) {
      this.setState({
        fileReadError: "Error reading file. Please check and try again",
      });
    }
  }

  downloadGeojson = () => {
    const { points } = this.state;
    const geoJsonString = JSON.stringify(getLineGeojsonFromPoints(points), null, 2);

    const blob = new Blob([geoJsonString], {});
    const linkElement = document.createElement('a');

    const url = window.URL.createObjectURL(blob);
    linkElement.href = url;
    linkElement.download = "line.geojson";
    linkElement.click();

    URL.revokeObjectURL(url);
  }

  onMapActionChange = (mapAction) => {
    this.setState({
      mapAction,
    });
  }

  deletePoint = (index) => {
    const { points } = this.state;
    const newPoints = _.reject(points, (p, i) => i === index);
    this.setState({
      points: newPoints,
      selectedPointIndex: index - 1
    });
  }

  deleteAllPoints = () => {
    this.setState({
      points: [],
    });
  };

  addPoint = (point) => {
    const { points, selectedPointIndex } = this.state;
    const newPoints = [...points];
    newPoints.splice(selectedPointIndex + 1, 0, point);
    this.setState({
      points: newPoints,
      selectedPointIndex: selectedPointIndex + 1
    });
  }

  movePoint = (point) => {
    const { points, selectedPointIndex } = this.state;
    const newPoints = [...points];
    newPoints[selectedPointIndex] = point;
    this.setState({
      points: newPoints,
    });
  }

  selectPoint = (index) => {
    this.setState({
      selectedPointIndex: index,
    });
  }

  render() {
    const { points, mapAction, selectedPointIndex } = this.state;
    return (
      <>
        <div id="sidebar">
          <input
            ref={this.importInput}
            type="file"
            id="import-input"
            onChange={this.readFile}
            onClick={(e) => {
              e.currentTarget.value = "";
            }}
          />
          <div>
            <div className="btn-group">
              <button className="selected" onClick={() => {this.importInput.current.click()}}>
                <img src={IconImport} alt="Import" className="icon" />
                Import</button>
              <button className="selected" onClick={this.downloadGeojson}>
              <img src={IconExport} alt="Export" className="icon" />
                Export
                </button>
            </div>
          </div>
          {
            _.size(points) > 0 && (
              <button id="delete-all-points" onClick={this.deleteAllPoints}>
                <img src={IconDelete} alt="Delete" className="icon" /> Delete all points
              </button>
            )
          }
          <div>
            <h4>Points on the map</h4>
            {
              _.size(points) === 0 && (
                <p id="no-points">No points added to the map. Click on the map or import a geojson file to get started</p>
              )
            }
            {
              _.map(points, (p, index) => (
                <div
                  key={index}
                  className={`point-item ${
                    // mapAction === MAP_ACTIONS.SELECT &&
                    index === selectedPointIndex ? "selected" : ""
                  }`}
                  onClick={() => this.selectPoint(index)}
                >
                  <div>
                    {p[0].toFixed(4)}, {p[1].toFixed(4)}
                  </div>
                  <button onClick={(e) => {
                    e.stopPropagation();
                    this.deletePoint(index);
                  }}>
                    <img src={IconDelete} alt="Delete" className="icon" />
                  </button>
                </div>
              ))
            }
          </div>      
        </div>
        <Map
          points={points}
          selectPoint={this.selectPoint}
          addPoint={this.addPoint}
          movePoint={this.movePoint}
          selectedPointIndex={selectedPointIndex}
        />
      </>
    );
  }
}

export default App;
